import { render, staticRenderFns } from "./webDialer.vue?vue&type=template&id=e1125964&scoped=true"
import script from "./webDialer.vue?vue&type=script&lang=js"
export * from "./webDialer.vue?vue&type=script&lang=js"
import style0 from "./webDialer.vue?vue&type=style&index=0&id=e1125964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1125964",
  null
  
)

export default component.exports